import { createFileRoute } from '@tanstack/react-router';
import { JourneysPeopleCreateHandoff } from '@/pages/workspaces/people/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/profiles/create` URL — the canonical segment for
 * accounts on the taxonomy rename (the Ember router flag-swaps
 * `people`/`profiles`). It always forwards to the Hydra page, same as the
 * `/journeys/people/create` twin.
 */
function JourneysProfilesCreateRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysPeopleCreateHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/profiles/create')({
  component: JourneysProfilesCreateRoute,
});
